module.exports = __webpack_public_path__ + "md.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/md.svg
// module id = 680
// module chunks = 0